<template>
  <div>
    <v-toolbar color="primary" class="p-0">
      <v-container>
        <v-row no-gutters align="center" justify="center">
          <v-col cols="2" align-self="center" class="text-left">
            <v-icon color="white" large
                    @click="changeMenuOpen">mdi-dots-vertical
            </v-icon>
          </v-col>
          <v-col cols="8">
            <v-img src="../../../assets/logo-white.svg" :alt="$store.state.text.app.appTitle"
                   contain class="pointer" @click="$router.push('/')"/>
          </v-col>
          <v-col cols="2" align-self="center" class="text-right">
            <v-icon color="white" large
                    @click="showSearchField=!showSearchField">mdi-magnify
            </v-icon>
          </v-col>
        </v-row>
      </v-container>
    </v-toolbar>
    <v-toolbar
      color="secondary"
      dense
      height="30"
    >
      <template v-if="showSearchField">
        <v-col cols="10" offset="1" align-self="center" class="searchField">
          <Search/>
        </v-col>
      </template>
    </v-toolbar>
    <v-fab-transition v-if='basketQuantity > 0'>
      <v-btn
        color="secondary"
        fab
        large
        dark
        bottom
        left
        class="v-btn--example"
        @click="$router.push('/cart')"
      >
        <v-badge
          color='light-blue darken-1'
          v-if='basketQuantity > 0'
          :content='basketQuantity'
        >
          <v-icon>mdi-cart-variant</v-icon>
        </v-badge>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
import Search from '@/components/Partials/TopBar/Search.vue';

export default {
  name: 'TopBarMobile',
  components: { Search },
  data() {
    return {
      showSearchField: false,
    };
  },
  methods: {
    changeMenuOpen() {
      this.$store.commit('setShowMobileMenu', !this.$store.state.showMobileMenu);
    },
  },
  computed: {
    basketQuantity() {
      return this.$store.state.basketQuantity;
    },
  },
};
</script>

<style scoped>
.topIcon {
  margin-top: 0.4em;
  font-size: 1.8em !important;
}

.container {
  padding: 0;
}

.searchField {
  margin-top: 1.1em;
}

.v-btn--example {
  position: fixed;
  bottom: 5px;
  left: 5px;
  z-index: 1000;
}
</style>
